/**
 * Menu Map Table Component
 */
export default function MenuMapTableComponent() {

  let onChangeCallback = () => { }

  // Render.
  let renderNode = (item) => {
    const { children = [], menuId, toggle, activation } = item;
    const hasChildren = children.length > 0;
    const checked = activation > 0;
    const indeterminate = activation === 2;

    return [
      m('tr.align-middle',
        m('td',
          m('input.form-check-input.cursor-pointer[type="checkbox"]', {
            name: menuId,
            checked,
            indeterminate,
            onchange: () => {
              toggle();
              onChangeCallback();
            },
          })
        ),
        m('td', m('span.cursor-text', item.menuId)),
        m('td', m('span.cursor-text', { style: `padding-left: ${(item.level - 1) * 50}px` }, '>' + item.name)),
        m('td', m('span.cursor-text', item.description)),
        m('td', m('span.cursor-text', item.category)),
        m('td', m('span.cursor-text', item.level)),
      ),
      hasChildren && children.map(child => renderNode(child))
    ]
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onChange) {
        onChangeCallback = vnode.attrs.onChange;
      }
    },
    view: (vnode) => {
      return vnode.attrs.data.map(item => renderNode(item))
    }
  }
}